import { createSelector } from '@ngrx/store';

export const selectShippingState = state => state.shipping;

export const selectShippingSettings = createSelector(
    selectShippingState,
    state => state.settings
);
